import _ from 'underscore';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { ISchedule } from '../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { ISubscription } from '../ServerApi/types/ISubscription';
import { IUser } from '../ServerApi/types/IUser';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';
import { CreatorUserStatus } from '../ServerApi/types/SubscriptionCreatorUserStatus';
import { IUserInfo } from '../models/IUserInfo';
import { Messages } from '~src/codegen/Localize';

export module SubscriptionMapper {

  const M = MapperHelper;

  export function map(
    subscriptions: ISubscription[],
    schedules: _.Dictionary<ISchedule>,
    sites: _.Dictionary<ISiteNameWithId>,
    users: _.Dictionary<IUser>
  ): ISubscriptionInfo[] {

    return _.map(subscriptions, (sub: ISubscription): ISubscriptionInfo => {
      return {
        id:         sub.id,
        subject:    sub.subject,
        canSpecifyDataCondition: sub.canSpecifyDataCondition,
        dataConditionPresent: sub.dataConditionType.toLowerCase() === 'DataPresent'.toLowerCase(),
        targetId:   sub.targetId,
        targetName: sub.targetFriendlyName || sub.targetName, // targetFriendlyName exists if targetName is GUID instead of human-readable name, otherwise targetFriendlyName is null
        targetType: sub.targetType.toLowerCase(),
        targetPath: sub.targetPath,
        canManageSubscription: sub.canManageSubscription,
        refreshExtractTriggered: sub.refreshExtractTriggered,
        lastSentAt: M.toDate(sub.lastSentAt),
        runNextAt:  M.toDate(sub.runNextAt),
        schedule:   schedules[sub.scheduleId],
        site:       sites[sub.siteId],
        user:       UserMapper.mapOne(users[sub.userId]),
        creator:    mapSubscriptionCreator(users[sub.creatorId], sub.creatorUserStatus),
        contentType: 'subscription',
        lastRunError: sub.detailedMessage,
        failed:     sub.failed,
        suspended:  sub.suspended,
        attachImage: sub.attachImage,
        attachPdf: sub.attachPdf,
        pageSizeOption: sub.pageSizeOption,
        pageOrientation: sub.pageOrientation,
        creatorUserStatus: sub.creatorUserStatus
      };
    });
  }

  function mapSubscriptionCreator(u: IUser, userStatus: CreatorUserStatus): IUserInfo {
    let userInfo = UserMapper.mapOne(u);
    switch (userStatus) {
      case CreatorUserStatus.REMOVED:
        userInfo.displayName = Messages.subscriptionCreatorUnknownUser();
        break;
      case CreatorUserStatus.HIDDEN:
        userInfo.displayName = Messages.hiddenUser();
        break;
      default: break;
    }
    return userInfo;
  }
}
